import { showError, requestJson, formPost } from "./trend-actions";

export function initialiseTrackedProductActions() {
    document.querySelectorAll(".btndetailtrack, .btndetailuntracked").forEach((button) => {
        button.addEventListener("click", async () => {
            const buttons = document.querySelectorAll(".btndetailtrack, .btndetailuntracked");
            buttons.forEach((item) => { item.disabled = true; });
            try {
                if (button.classList.contains("btndetailuntracked")) {
                    await requestJson("/insights/reports/" + encodeURIComponent(button.dataset.id), { method: "DELETE" });
                } else {
                    await formPost("/insights/reports", { term: button.dataset.term });
                }
                window.location.reload();
            } catch (error) {
                showError(button, "Unable to update your tracked product. Please try again.");
                buttons.forEach((item) => { item.disabled = false; });
            }
        });
    });
}

export function initialiseDropshipProducts() {
    const section = document.getElementById("dropship-products-section");
    if (!section || !["1", "true"].includes(section.dataset.hasDropshipAccess || "")) return;
    const container = document.getElementById("dropship-products-container");
    const query = new URLSearchParams({ query: section.dataset.reportTitle, limit: "12" });
    requestJson("/api/insights/search/dropship_products?" + query).then((response) => {
        if (!Array.isArray(response)) throw new Error("Unexpected product response");
        const products = response.filter((product) => product.image_url || product.all_image_urls?.length);
        container.replaceChildren();
        if (!products.length) {
            section.hidden = true;
            return;
        }
        products.forEach((product) => container.appendChild(productCard(product, section.dataset.imageFallback)));
    }).catch(() => {
        container.replaceChildren();
        const message = document.createElement("p");
        message.className = "font-size-14";
        message.setAttribute("role", "status");
        message.textContent = "Products could not be loaded. Please refresh the page to try again.";
        container.appendChild(message);
    });
}

function safeImageUrl(value, fallback) {
    try {
        const url = new URL(value, window.location.origin);
        return ["https:", "http:"].includes(url.protocol) ? url.href : fallback;
    } catch (error) {
        return fallback;
    }
}

function productCard(product, fallback) {
    const column = document.createElement("div");
    column.className = "col-lg-4 col-md-4 col-6";
    column.innerHTML = '<div class="card p-lg-4 p-3 border-0 rounded-4"><button type="button" class="btn btn-add border-0 d-flex overflow-hidden rounded-pill position-absolute top-0 start-0 mt-lg-3 ms-lg-3 mt-2 ms-2 font-size-14 text-white align-items-center pt-0 pb-0 pe-0"><span class="me-3 text-nowrap lh-1"></span></button><div class="mb-3 img-container d-flex justify-content-center"><img loading="lazy" decoding="async" class="img-fluid rounded-3 my-auto mh-100 w-auto" width="250" height="250"></div><div class="text-truncate pt-3"></div><div class="font-family-raleway font-size-22 font-size-md-18 font-weight-semibold"></div></div>';
    const button = column.querySelector("button");
    const label = button.querySelector("span");
    let imported = Boolean(product.imported);
    const update = () => {
        button.classList.toggle("active", imported);
        button.setAttribute("aria-pressed", imported ? "true" : "false");
        label.textContent = (imported ? "Remove from" : "Add to") + " Import List";
    };
    update();
    button.addEventListener("click", async () => {
        button.disabled = true;
        try {
            await formPost(imported ? "/ds/remove_from_list" : "/ds/add_to_list", { dropship_product_id: product.id });
            imported = !imported;
            update();
            column.querySelector(".trend-action-error")?.remove();
        } catch (error) {
            showError(button, "Unable to update your import list. Please try again.");
        } finally {
            button.disabled = false;
        }
    });
    const image = column.querySelector("img");
    image.src = safeImageUrl(product.image_url || product.all_image_urls?.[0], fallback);
    image.alt = String(product.product_title || "");
    image.addEventListener("error", () => { image.src = fallback; }, { once: true });
    column.querySelector(".text-truncate").textContent = String(product.product_title || "");
    column.querySelector(".font-family-raleway").textContent = "USD $" + (product.sale_price ?? "");
    return column;
}
